import { o_util } from "../common/namespaces";
import type { GlobalUtils } from "../exports/index.js";

/**
 *
 *
 *
 */
export type EventSync = GlobalUtils["event"];

/**
 *
 *
 *
 */
export const eventSync: EventSync = o_util.event;